import { Api } from '@sodamnfoolish/sjc-backend-types';

export function isBonkBubble(bubble: Api.Pump.DTO.PumpFunBubble | Api.Bonk.DTO.LetsBonkBubble): bubble is Api.Bonk.DTO.LetsBonkBubble {
    return 'letsBonkTokens' in bubble;
}
